import e from "./ghl-ui.es1505.js";
import a from "./ghl-ui.es1326.js";
import m from "./ghl-ui.es1466.js";
function f(r, t) {
  m(2, arguments);
  var o = e(t);
  return a(r, o * 12);
}
export {
  f as default
};
